var _path, _g, _path2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocUploadSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 213,
    viewBox: "0 0 213 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_311_80681)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_311_80681",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 213,
    height: 213
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213 0H0V213H213V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_311_80681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.307 19.3745C154.529 19.3745 193.62 58.4657 193.62 106.687C193.62 154.909 154.529 194 106.307 194C58.0853 194 18.9941 154.909 18.9941 106.687C18.9941 58.4657 58.0853 19.3745 106.307 19.3745Z",
    fill: "#BDBDBA"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_311_80681)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_311_80681",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 57,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156 57H56V157H156V57Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_311_80681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.2501 78.2501V92.5451C77.2501 93.9391 76.1211 95.0681 74.7281 95.0681C73.3341 95.0681 72.2051 93.9391 72.2051 92.5451V75.7281C72.2051 74.3341 73.3341 73.2051 74.7281 73.2051H91.5451C92.9391 73.2051 94.0681 74.3341 94.0681 75.7281C94.0681 77.1211 92.9391 78.2501 91.5451 78.2501H77.2501ZM132.75 78.2501H118.454C117.062 78.2501 115.932 77.1211 115.932 75.7281C115.932 74.3341 117.062 73.2051 118.454 73.2051H135.272C136.666 73.2051 137.795 74.3341 137.795 75.7281V92.5451C137.795 93.9391 136.666 95.0681 135.272 95.0681C133.879 95.0681 132.75 93.9391 132.75 92.5451V78.2501ZM77.2501 133.75H91.5451C92.9391 133.75 94.0681 134.879 94.0681 136.272C94.0681 137.666 92.9391 138.795 91.5451 138.795H74.7281C73.3341 138.795 72.2051 137.666 72.2051 136.272V119.454C72.2051 118.062 73.3341 116.932 74.7281 116.932C76.1211 116.932 77.2501 118.062 77.2501 119.454V133.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.069 104.75C112.228 104.75 104.25 112.728 104.25 122.569C104.25 132.41 112.228 140.388 122.069 140.388C131.91 140.388 139.888 132.41 139.888 122.569C139.888 112.728 131.91 104.75 122.069 104.75Z",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.875 121.625L119.5 127.625L130.625 116.75",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5 92.5H121.125",
    stroke: "white",
    strokeWidth: 3.87298,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.25 106.25L106.85 106",
    stroke: "white",
    strokeWidth: 4.38178,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5 120L96.75 119.75",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_80681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 213,
    height: 213,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_311_80681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(56 57)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocUploadSuccess);
export default __webpack_public_path__ + "static/media/doc_upload_success.0937617eafe669dc08d20c630976fc62.svg";
export { ForwardRef as ReactComponent };